import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Home = () => {
	const icons_style = {
		fontSize: "75%",
		paddingLeft: "1vw",
		color: "#CED9DF",
	};

	return (
		<div className="Home">
			<div className="Home-name">Jake Tockerman</div>
			<div className="Home-embeds">
				<a
					style={icons_style}
					href="https://www.linkedin.com/in/jacobtockerman/"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FontAwesomeIcon icon={faLinkedin} />
				</a>
				<a
					style={icons_style}
					href="https://github.com/jaketockerman"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FontAwesomeIcon icon={faGithub} />
				</a>
			</div>
		</div>
	);
};
export default Home;
